import { inject } from '@angular/core';
import { MixpanelService } from 'src/app/@services/mixpanel.service';
import { environment } from 'src/environments/environment';

export function appMixpanelInitializer() {
  const mixpanelService = inject(MixpanelService);

  return (): void => {
    if (environment.mixpanelToken) {
      mixpanelService.initialize(environment.mixpanelToken);
    }
  };
}
